export const classes = {
  card: 'place-between pl-4 pr-3 py-3 bg-grey-2 dark:bg-white/[0.06] hover:bg-grey-3 dark:hover:bg-white/[0.1] text-grey-8 dark:text-mauve-1 shadow-none my-2',
  content:
    'flex flex-col justify-start items-start grow text-left outline-none cursor-pointer min-w-0',
  details: 'flex flex-col w-full min-w-0',
  title: 'pointer-events-none text-sm truncate w-full',
  subtitle:
    'pointer-events-none text-xs text-grey-7 dark:text-mauve-2 mt-1 truncate w-full',
  closeIcon: 'close-icon text-grey-8 dark:text-mauve-1 transition-all',
};

export const styles = {
  card: {
    '&:hover .close-icon': {
      opacity: 1,
    },
    '& .close-icon': {
      opacity: 0,
    },
  },
};
